module.exports = __webpack_public_path__ + "static/media/icon-instagram.48a204c8.svg";